function PathNav(params) {
    if (!params.element || !params.container) {
        return;
    }

    this.setDefaults(params);
    this.addListeners();
};

PathNav.prototype.setDefaults = function (params) {
    this.element = $(params.element);
    this.container = $(params.container);
    this.direction = params.direction || true;
    this.speed = params.speed || 'slow';
};

PathNav.prototype.addListeners = function () {
    this.element.find('.partner-landing__choose-your-path-tab').on('click touchstart', this.onItemClick.bind(this));
};

PathNav.prototype.onItemClick = function (e) {
    e.preventDefault();
    e.stopPropagation();

    var width = this.container[0].scrollWidth * (this.direction ? 1 : -1);
    var offset = (this.container[0].scrollWidth - this.element[0].scrollWidth) * (this.direction ? 1 : 0);

    $('.partner-landing__choose-your-path-tab').toggleClass('active');
    this.container.animate({
        scrollLeft: width
    }, this.speed).find('.nav-dots').animate({
        left: offset
    }, 'slow');

    this.direction = !this.direction;
};

(function ($) {
    $('.partner-landing__choose-your-path-tabs-wrapper').each(function (index, element) {
        new PathNav({
            element: $(element),
            container: '.partner-landing-columns__wrapper',
            direction: true,
            speed: 'slow'
        });
    });
})(jQuery);